import { Icon } from './Icon.jsx';
import styles from './PlaceholderArt.module.css';

/**
 * Stands in for an image that does not exist yet, and says so.
 *
 * The label is not optional and the component takes no image prop — the
 * whole point is that it cannot be quietly dressed up to look like real
 * evidence (PRODUCT.md, principle 1).
 */
export function PlaceholderArt({ label = 'Renderings coming soon', icon = 'house', className = '' }) {
  return (
    <div className={`${styles.placeholder} ${className}`.trim()}>
      <Icon name={icon} strokeWidth={1.2} />
      <span className={styles.tag}>{label}</span>
    </div>
  );
}
